export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-3-42086d5054b593beccffaeb3795d322c.png";